import React from 'react';
import styles from './CarouselPillButton.module.css';

interface CarouselPillButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  icon?: React.ReactNode;
  $gap?: number;
}

export const CarouselPillButton = React.forwardRef<
  HTMLButtonElement,
  CarouselPillButtonProps
>(({ label, icon, $gap = 8, className, style, ...rest }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={[styles.root, className].filter(Boolean).join(' ')}
      style={{ ['--pill-gap' as any]: `${$gap}px`, ...style }}
      {...rest}
    >
      {icon}
      {label}
    </button>
  );
});

CarouselPillButton.displayName = 'CarouselPillButton';
